<ng-container *ngIf="variant === 'kp'; else defaultVariant">
  <label class="kp-textarea">
    <span *ngIf="label" class="kp-textarea__label" [class.kp-textarea__label--required]="required">{{ label }}</span>
    <textarea
      class="kp-textarea__input"
      [formControl]="control"
      [maxlength]="maxlength"
      [rows]="minRows"
      [required]="required"
      [attr.placeholder]="placeholder"
      [attr.name]="name"
    ></textarea>
  </label>
</ng-container>
<ng-template #defaultVariant>
  <mat-form-field [appearance]="appearance">
    <mat-label>{{ label }}</mat-label>
    <textarea
      matInput
      [formControl]="control"
      [maxlength]="maxlength"
      cdkTextareaAutosize
      [cdkAutosizeMinRows]="minRows"
      [cdkAutosizeMaxRows]="maxRows"
      [required]="required"
      [placeholder]="placeholder"
      [name]="name"
    ></textarea>
  </mat-form-field>
</ng-template>
